import React, { createContext, useState, useContext, useEffect } from 'react';

// Définition des thèmes
export const themes = {
    light: {
        name: 'light',
        colors: {
            background: '#ffffff',
            secondaryBackground: '#f8f9fa',
            text: '#222222',               // Assombri pour un meilleur contraste
            secondaryText: '#444444',      // Assombri pour un meilleur contraste
            accent: '#4812B8',             // Légèrement assombri pour meilleur contraste sur fond clair
            accentGradient: 'linear-gradient(45deg, #4812B8, #7B3FFF)',
            cardBackground: '#ffffff',
            borderColor: '#dddddd',        // Assombri pour un meilleur contraste
            headerTransparent: 'transparent',
            headerSolid: 'rgba(255, 255, 255, 0.98)', // Plus opaque pour meilleur contraste
            navText: '#222222',            // Assombri pour un meilleur contraste
            navTextLight: '#f5f5f7',
            iconBackground: '#e8e8e8',     // Assombri pour un meilleur contraste
            iconColor: '#444444',          // Assombri pour un meilleur contraste
            testimonialBackground: '#f8f9fa',
            footerBackground: '#f0f0f0',   // Légèrement assombri pour améliorer le contraste
            hamburgerColor: '#222222'      // Assombri pour un meilleur contraste
        }
    },
    dark: {
        name: 'dark',
        colors: {
            background: '#0f1114',
            secondaryBackground: '#13151a',
            text: '#ffffff',               // Éclairci pour un meilleur contraste
            secondaryText: '#d0d0d8',      // Éclairci pour un meilleur contraste
            accent: '#7B3FFF',             // Éclairci pour meilleur contraste sur fond foncé
            accentGradient: 'linear-gradient(45deg, #7B3FFF, #9B6AFF)',
            cardBackground: 'rgba(30, 33, 43, 0.95)', // Plus opaque et légèrement éclairci
            borderColor: 'rgba(255, 255, 255, 0.15)', // Plus visible
            headerTransparent: 'transparent',
            headerSolid: 'rgba(15, 17, 20, 0.98)', // Plus opaque pour meilleur contraste
            navText: '#ffffff',            // Blanc pur pour meilleur contraste
            navTextLight: '#ffffff',
            iconBackground: '#25282f',     // Légèrement éclairci
            iconColor: 'white',
            testimonialBackground: '#181b22', // Légèrement éclairci
            footerBackground: '#0c0e10',
            hamburgerColor: 'white'
        }
    }
};

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    // Gestion du thème
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'light') {
            return themes.light;
        } else if (savedTheme === 'dark') {
            return themes.dark;
        }
        return themes.light;
    });

    useEffect(() => {
        localStorage.setItem('theme', theme.name);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(theme.name === 'light' ? themes.dark : themes.light);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export default ThemeContext;